/**
 * Canonical PDP path segment and slug matching across Gallery, Home, PDP, etc.
 */

export function slugifyProductName(name) {
  if (name == null || name === '') return '';
  try {
    return String(name)
      .normalize('NFD')
      .replace(/\p{M}/gu, '')
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '')
      .replace(/-+/g, '-');
  } catch {
    return String(name)
      .toLowerCase()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '')
      .replace(/-+/g, '-');
  }
}

/** Path segment stored in URLs (unencoded): prefer API slug, else ASCII slugified name */
export function getProductPathSegment(product) {
  if (!product) return 'item';
  const s = typeof product.slug === 'string' ? product.slug.trim() : '';
  if (s) return s;
  const fromName = slugifyProductName(product.name || '');
  return fromName || 'item';
}

/** Use with react-router `<Link to={productDetailPath(p)}>` */
export function productDetailPath(product) {
  const seg = getProductPathSegment(product);
  return `/product/${encodeURIComponent(seg)}`;
}

/** When only display name exists (social feed hints, etc.). */
export function productDetailPathFromName(productName) {
  const seg = slugifyProductName(productName || '') || 'item';
  return `/product/${encodeURIComponent(seg)}`;
}

/** useParams `:slug` is decoded */
export function decodeProductRouteSlug(routeSlug) {
  if (!routeSlug) return '';
  try {
    return decodeURIComponent(routeSlug);
  } catch {
    return routeSlug;
  }
}

/** PDP loader: catalog product matches current route slug (supports legacy links) */
export function catalogProductMatchesRouteSlug(product, routeSlugRaw) {
  if (!product || routeSlugRaw == null) return false;
  const slug = decodeProductRouteSlug(String(routeSlugRaw));
  if (product.id === slug) return true;
  const primary = getProductPathSegment(product);
  if (primary === slug) return true;
  if (slugifyProductName(product.name || '') === slug) return true;
  const legacySpaces = String(product.name || '')
    .toLowerCase()
    .replace(/\s+/g, '-');
  if (legacySpaces === slug) return true;
  return false;
}
